module.exports = __webpack_public_path__ + "static/img/happy.448b18c5.png";